import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "control-panel" }
const _hoisted_2 = { class: "row submit-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-save left" }, null, -1)
const _hoisted_4 = { class: "text-label" }
const _hoisted_5 = { class: "side-controls" }
const _hoisted_6 = { class: "option-set" }
const _hoisted_7 = ["for", "title"]
const _hoisted_8 = { class: "instructions" }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PersonForm = _resolveComponent("PersonForm")!
  const _component_Button = _resolveComponent("Button")!
  const _component_KutaTable = _resolveComponent("KutaTable")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_ChartList = _resolveComponent("ChartList")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["kutas-container", _ctx.wrapperClasses])
  }, [
    _createElementVNode("form", _hoisted_1, [
      _createVNode(_component_PersonForm, {
        context: "main",
        onUpdate: _ctx.updatePerson,
        pairRefs: _ctx.pairRefs
      }, null, 8, ["onUpdate", "pairRefs"]),
      _createVNode(_component_PersonForm, {
        context: "partner",
        onUpdate: _ctx.updatePerson,
        pairRefs: _ctx.pairRefs
      }, null, 8, ["onUpdate", "pairRefs"]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.hasPairs)
          ? _withDirectives((_openBlock(), _createElementBlock("strong", {
              key: 0,
              class: "circle pair-num",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleChartList && _ctx.toggleChartList(...args)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.currentRefNum), 1)
            ])), [
              [
                _directive_tooltip,
                _ctx.refNumTooltip,
                void 0,
                { top: true }
              ]
            ])
          : _createCommentVNode("", true),
        _createVNode(_component_Button, { onClick: _ctx.save }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.saveLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.hasPairs)
          ? _withDirectives((_openBlock(), _createElementBlock("i", {
              key: 1,
              class: "pi pi-plus-circle reset-trigger trigger large",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
            }, null, 512)), [
              [
                _directive_tooltip,
                _ctx.resetTooltip,
                void 0,
                { right: true }
              ]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_TabView, {
      class: "results-container",
      onTabClick: _ctx.handleTabChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (tRow, tIndex) => {
          return (_openBlock(), _createBlock(_component_TabPanel, {
            key: tRow.itemKey,
            header: _ctx.tables[tIndex].name
          }, {
            default: _withCtx(() => [
              _createVNode(_component_KutaTable, {
                kutaItems: tRow.kutas,
                p1Name: _ctx.p1Name,
                p2Name: _ctx.p2Name,
                keyName: _ctx.tables[tIndex],
                open: _ctx.isOpen(tIndex)
              }, null, 8, ["kutaItems", "p1Name", "p2Name", "keyName", "open"])
            ]),
            _: 2
          }, 1032, ["header"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["onTabClick"]),
    _createElementVNode("aside", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comboGrahaItems, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.itemKey,
            class: _normalizeClass(["item row", item.classNames])
          }, [
            _createVNode(_component_RadioButton, {
              value: item.key,
              modelValue: _ctx.gKey,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.gKey) = $event)),
              id: item.idKey
            }, null, 8, ["value", "modelValue", "id"]),
            _createElementVNode("label", {
              for: item.idKey,
              title: item.name
            }, _toDisplayString(item.name), 9, _hoisted_7)
          ], 2))
        }), 128))
      ])
    ]),
    _createVNode(_component_ChartList, {
      pairs: _ctx.pairs,
      refNum: _ctx.currentRefNum,
      puid: _ctx.puid
    }, null, 8, ["pairs", "refNum", "puid"]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.showInstructions)
        ? (_openBlock(), _createElementBlock("article", {
            key: 0,
            innerHTML: _ctx.instructions
          }, null, 8, _hoisted_9))
        : _createCommentVNode("", true)
    ]),
    (_ctx.hasPairs)
      ? _withDirectives((_openBlock(), _createElementBlock("i", {
          key: 0,
          class: "pi pi-cog chartlist-trigger trigger",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleChartList && _ctx.toggleChartList(...args)))
        }, null, 512)), [
          [
            _directive_tooltip,
            _ctx.managePairsTip,
            void 0,
            { left: true }
          ]
        ])
      : _createCommentVNode("", true)
  ], 2))
}